module.exports = __webpack_public_path__ + "static/img/key-warehouse-2.9d9a126.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/key-warehouse-2.png
// module id = nzDD
// module chunks = 1